import { cmsGlobal } from "@/common/fhtGlobalEnv";
let publicPath = cmsGlobal.Cms.IsCustomDomain ? "/dist/" : "https://assets2.fht360.cn/cms/";
if (cmsGlobal.Env.DEBUG) {
    publicPath = "http://localhost:8051/";
}

console.log("setting __webpack_public_path__ to:", publicPath);
__webpack_public_path__ = publicPath;
